import type { GridColDef } from "@mui/x-data-grid-premium";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import type { FundWithFieldValues } from "../../../../api/types/fundStructureTypes";

export const getFundPath = (fundId: string): string => `./${fundId}/main`;

export const columnDefinitions: GridColDef<FundWithFieldValues>[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 2,
    renderCell: ({ row }) => <GridTextHoverLink to={getFundPath(row.id)} text={row.name} />,
  },
  {
    field: "stage",
    headerName: "Stage",
    flex: 1,
    valueGetter: (_, row) => {
      const stage = row.fieldValues["Stage"]?.toString();
      return stage ? autoFormatCamelCase(stage) : "";
    },
  },
  {
    field: "investorsCount",
    headerName: "Investors",
    flex: 1,
  },
];
